import styled from '@emotion/styled';

import { ApiErrorPage, MainContainer } from '@britishcouncil/react-solas-ors3';
import { Button } from '@britishcouncil/react-solas';
import { OidcContext } from '@britishcouncil/react-oidc-auth';

export const LoginError = () => {
  const userManager = OidcContext.useAuth();
  const handleLogin = () => {
    userManager.signinRedirect();
  };

  return (
    <MainContainer>
      <ApiErrorPage
        title="Login error"
        errorMessage="It looks like log in went wrong. Please try again in a few minutes."
      />
      <StyledButton intent="default" onClick={handleLogin}>
        Log in
      </StyledButton>
    </MainContainer>
  );
};

const StyledButton = styled(Button)`
  margin: 10px auto;
`;
